(function () {
  'use strict';

  function isProductPage() {
    var main = document.querySelector('main[data-template]');
    if (main && /product/.test(main.getAttribute('data-template') || '')) return true;
    return /\/products\//.test(window.location.pathname);
  }

  function buildStickyAtc() {
    if (!isProductPage()) return;
    if (document.getElementById('plugs-atc')) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var realBtn = form.querySelector('button[type="submit"], [type="submit"]');
    if (!realBtn) return;

    var titleEl = document.querySelector('h1');
    var title = titleEl ? titleEl.textContent.trim() : '';
    if (title.length > 28) title = title.slice(0, 28) + '…';

    var priceEl = document.querySelector('[class*="price__regular"], [class*="price"]');
    var price = priceEl ? priceEl.textContent.trim().split('\n')[0] : '';

    var bar = document.createElement('div');
    bar.id = 'plugs-atc';
    bar.className = 'is-on';
    bar.innerHTML =
      '<div class="plugs-atc-info">' +
        '<span class="plugs-atc-title"></span>' +
        '<span class="plugs-atc-price"></span>' +
      '</div>' +
      '<button type="button" class="plugs-atc-btn">הוסף לסל</button>';

    bar.querySelector('.plugs-atc-title').textContent = title;
    bar.querySelector('.plugs-atc-price').textContent = price;

    bar.querySelector('.plugs-atc-btn').addEventListener('click', function () {
      var picker = document.querySelector('variant-picker, [class*="variant-picker"]');
      var target = picker || form;
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    document.body.appendChild(bar);
    document.body.classList.add('plugs-has-atc');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.4 }).observe(realBtn);
    }
  }

  function init() {
    try { buildStickyAtc(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
